<template>
  <div>
    <div class="content-header row">
      <div class="content-header-left col-12 mb-2 mt-1">
        <div class="row breadcrumbs-top">
          <div class="col-12">
            <div class="card">
              <div class="card-content">
                <div class="card-header headerAlign">
                  <div>
                    <router-link :to="{name:'CLOUsersPage', params:{org: orgId }}">
                    <span style="display: inline-block; cursor: pointer" >
                      <img :src="backIcon" class="titleFont" alt="back icon">
                      <h5 style="display: inline-block; transform: translate(23px, -20px);" class="backFont "> {{
                          $t('clo_user_view_back_button')
                      }} </h5>
                    </span>
                    </router-link>
                    <h5 class="card-title headingAlign">{{ $t('clo_user_view_heading') }} </h5>
                  </div>
                </div>
                <div class="card-body card-dashboard">
                  <Alert :text="apiErrorText" type="danger" dismissable="false" v-if="apiErrorText != ''" />
                  <form @submit.prevent="handleSubmit">
                    <div class="form-group row">
                      <div class="col-md-6 col-sm-12">
                        <label for>{{ $t('clo_user_view_first_name_label') }}</label>

                        <input type="text" class="form-control inputTab" v-model="target.name" disabled />

                      </div>
                      <div class="col-md-6 col-sm-12">
                        <label for>{{ $t('clo_user_view_role_label') }}</label>
                        <select class="form-control inputTab" v-model="target.type" disabled>
                          <option selected value="cloowner">{{ $t('clo_user_role_dropdown_organization_admin_option') }}
                          </option>
                          <option value="project_manager">{{ $t('clo_user_role_dropdown_project_manager_option') }}
                          </option>
                          <option value="complaint_feedback_lead">{{
                              $t('clo_user_role_dropdown_complaints_and_feedback_lead_option')
                          }} </option>
                          <option value="clopacto_user_success_lead">{{
                              $t('clo_user_role_dropdown_pacto_user_success_lead_option')
                          }} </option>
                        </select>
                      </div>
                    </div>

                    <div class="form-group row">

                      <div class="col-md-6 col-sm-12">
                        <label for>{{ $t('clo_user_view_email_label') }}</label>
                        <input type="text" class="form-control inputTab" v-model="target.email" disabled />
                      </div>
                      <div class="col-md-6 col-sm-12">
                        <label for>{{ $t('clo_user_view_phone_label') }}</label>
                        <div class="marginDiv">
                          <PhoneNumberInput :phoneNumber="phoneNumber" v-model="phoneNumber" disabled addClass="form-control inputTabData" />
                        </div>
                      </div>

                    </div>
                    <div class="form-group row">
                      <div class="col-md-6 col-sm-12 ">
                        <label for>{{ $t('clo_user_view_status_label') }}</label>
                        <select class="form-control inputTab" v-model="target.status" disabled>
                          <option selected value="joined"> {{ $t('clo_user_status_dropdown_active_option') }} </option>
                          <option value="banned"> {{ $t('clo_user_status_dropdown_inactive_option') }} </option>
                        </select>
                      </div>
                      <div class="col-md-6 col-sm-12">
                        <label for>{{ $t('clo_user_view_country_label') }}</label>
                        <select class="form-control inputTab" v-model="countryData" disabled>
                          <option value="default" disabled>{{ $t('clo_user_add_user_popup_country_dropdown_default') }}
                          </option>
                          <option v-for="(country, index) in totalCountries" :value="country" :key="index">{{
                              countryName(country)
                          }}
                          </option>

                        </select>
                      </div>

                    </div>
                  </form>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Alert from "@/components/Alerts";
import { getCountryName } from '@/app-assets/js/get-countries.js'
import "@/app-assets/css/pages/authentication.css";
import PhoneNumberInput from "@/components/PhoneNumberInput/PhoneNumberInput";

export default {
  components: {
    Alert,
    PhoneNumberInput
  },
  data() {
    return {
      target: {},
      userId: this.$route.params.uid,
      orgId: this.$route.params.org,
      backIcon: require('@/assets/backIcon.png').default,
      error: false,
      phoneNumber: 0,
      data: {},
      apiErrorText: "",
      dialCode: 0,
      closeImage: require('@/assets/close.png').default,
      totalCountries: [],
      countryData: 'default'
    }
  },
  methods: {

    getUserById() {
      let self = this;
      this.$apiCall.get(`/v1/users/${this.userId}`).then((response) => {
        self.target = response.data;
        self.phoneNumber = self.target.phoneNumber
        self.countryData = self.target.currentCountry
      });
    },
    countryName(element) {
      if (element) {
        return getCountryName(element.toUpperCase())
      }
    },
    getActiveCountries() {
      const countries = localStorage.getItem('activeCountries');
      this.countryData = (countries && countries != '') ? countries.split(',') : ["LB", "JO"];
    },
    getCountryData() {
      let self = this;
      console.log("dropdown")
      this.$apiCall.get(`v1/clo-organization/${self.orgId}/countries`).then(function (response) {
        console.log("dropdown-resp", response)

        
        self.totalCountries = response.data
        console.log("total", self.totalCountries)
      })
    },
  },




  mounted() {
    console.log("view-user")
    this.getUserById()
    this.getCountryData()
    console.log("target", this.target)
  }
}
</script>

<style scoped>
.inputTab {
  height: 3em;
  width: 35em;
}

@media (min-width: 768px) and (max-width: 1366px) {
  .inputTab {
    height: 3em;
    width: 27em;
  }
}

.titleFont {
  text-align: center;
  margin-right: 12%;

}

.headingAlign {
  margin-left: 23em;
  display: inline-block;
  transform: translate(101px, -20px);
}

@media (min-width: 768px) and (max-width:1366px) {
  .headingAlign {
    margin-left: 23em;
    display: inline-block;
    transform: translate(-145px, -20px);
  }
}

.backFont {
  text-transform: uppercase;
  font-size: 15px;
  font-weight: 500;
}

.headerAlign {
  border-width: 2px;
  height: 6em;
}

.alert {
  padding: 5px 10px;
  border: 1px solid #ff72728a;
  display: inline-block;
  color: #d48888;
  border-radius: 4px;
}

.resetPasswordHeading {
  color: #4A0A1E;
  font-size: 18px !important;
  font-weight: 450 !important;
}

.inputHeight {
  height: 3.5em;
}

.modalPopStyle {
  margin-left: 44em;
  margin-top: 182px;
}

.okButtonStyle {
  width: 8em;
}

.modalFooter {
  border-top: 1px solid #DFE3E7;
}

.resetPasswordSuccessHeading {
  color: #767676;
  font-size: 20px !important;
  font-weight: 400 !important;
  text-align: center;
  margin-top: 4%;
}

.resetPasswordDialogue {
  height: 19em;
  border-radius: 1rem !important;
  margin-top: 35%;
}

.flagAlign {
  transform: translate(-35em, 0px);
  border: 0px;
}

@media (max-width:1366px) {
  .resetPasswordDialogue {
    height: 19em;
    border-radius: 1rem !important;
    transform: translate(-17em, -46px);
  }

  .flagAlign {
    transform: translate(-27em, 0px);
    border: 0px;
  }

  .marginDiv {
    display: flex;
    width: 33em;
  }
}

.resetPasswordPopup {
  height: 28em;
  border-radius: 1rem !important;
  margin-top: 17em;
  margin-left: 6em;
}

.passwordTitle {
  white-space: nowrap;
  font-size: 14px;
}

.resetPasswordStyle {
  display: inline-block;
  transform: translate(81em, -56px);
  margin-left: 142px
}

@media (min-width: 768px) and (max-width: 1366px) {
  .resetPasswordStyle {
    display: inline-block;
    transform: translate(45em, -56px);
    margin-left: 142px
  }
}

.inputTabData {
  height: 3em;
  width: 35em;
  border: none;
  background-color: #F2F4F4;
}

.marginDiv {
  display: flex;
}

.buttonWidth {
  width: 8em;
}

@media (min-width: 768px) and (max-width: 1366px) {
  .inputTabData {
    height: 3em;
    width: 27em;
  }
}
</style>
